import { intl } from './intl';

export const { t: sharePanelT, Message: SharePanelMessage } = intl.createMessages({
    muteVideo: {
        ru: 'Запускать видео без звука',
        en: 'Start video muted',
    },
    autoplayVideo: {
        ru: 'Запускать видео автоматически',
        en: 'Start video automatically',
    },
    startFromTimecode: {
        ru: 'Начинать видео с указанной временной метки',
        en: 'Start video from specified timestamp',
    },
    startLabel: {
        ru: 'Начало:',
        en: 'Start:',
    },
    invalidTimeFormat: {
        ru: 'Неверный формат времени. Используйте HH:MM:SS или MM:SS',
        en: 'Invalid time format. Use HH:MM:SS or MM:SS',
    },
    wikiInterfaceInfo: {
        ru: 'Подробнее о старом и новом интерфейсе Wiki в',
        en: 'More about old and new Wiki interface in',
    },
    post: {
        ru: 'посте',
        en: 'post',
    },
    pasteTypeIframe: {
        ru: 'iframe',
        en: 'iframe',
    },
    pasteTypeLink: {
        ru: 'link',
        en: 'link',
    },
    pasteTypeWikiOld: {
        ru: 'wiki old',
        en: 'wiki old',
    },
    pasteTypeWiki: {
        ru: 'wiki | startrek',
        en: 'wiki | startrek',
    },
});
